// global cookie cache
const cookies = {};

export function getCookie(key: string) {
	if (cookies[key]) {
		return cookies[key];
	}

	const all = document.cookie.split('; ');

	for (let i = all.length - 1; i >= 0; i--) {
		const cookie = all[i].split('=');
		cookies[cookie[0]] = cookie[1];
	}

	return cookies[key];
}

export function setCookie(key: string, value: string, date: Date, secure = true, path = '/', domain?: string) {
	const cookie = [`${key}${value ? `=${value}` : '='}`, `expires=${date.toUTCString()}`, `path=${path}`];

	if (domain) {
		cookie.push(`domain=${domain}`);
	}

	if (secure) {
		cookie.push(`secure`);
	}

	delete cookies[key];
	document.cookie = cookie.join(';');
}

export function deleteCookie(key: string, path = '/') {
	if (getCookie(key)) {
		delete cookies[key];
		document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
	}
}
